// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 61 hooks for backend/interviews.

import { useBackend } from '../useBackend'

/** POST /api/interviews/addDriverIncident */
export function useAddDriverIncident<T = any>() {
  return useBackend<T>('interviews/addDriverIncident')
}

/** POST /api/interviews/addInterviewReferee */
export function useAddInterviewReferee<T = any>() {
  return useBackend<T>('interviews/addInterviewReferee')
}

/** POST /api/interviews/checkIdConflict */
export function useCheckIdConflict<T = any>() {
  return useBackend<T>('interviews/checkIdConflict')
}

/** POST /api/interviews/classifyInterviewReferee */
export function useClassifyInterviewReferee<T = any>() {
  return useBackend<T>('interviews/classifyInterviewReferee')
}

/** POST /api/interviews/commentOnApplication */
export function useCommentOnApplication<T = any>() {
  return useBackend<T>('interviews/commentOnApplication')
}

/** POST /api/interviews/getAccess */
export function useGetAccess<T = any>() {
  return useBackend<T>('interviews/getAccess')
}

/** POST /api/interviews/getApplicationComments */
export function useGetApplicationComments<T = any>() {
  return useBackend<T>('interviews/getApplicationComments')
}

/** POST /api/interviews/getApplications */
export function useGetApplications<T = any>() {
  return useBackend<T>('interviews/getApplications')
}

/** POST /api/interviews/getBankDetailFixups */
export function useGetBankDetailFixups<T = any>() {
  return useBackend<T>('interviews/getBankDetailFixups')
}

/** POST /api/interviews/getBookingAlerts */
export function useGetBookingAlerts<T = any>() {
  return useBackend<T>('interviews/getBookingAlerts')
}

/** POST /api/interviews/getContractStatus */
export function useGetContractStatus<T = any>() {
  return useBackend<T>('interviews/getContractStatus')
}

/** POST /api/interviews/getCurrentManager */
export function useGetCurrentManager<T = any>() {
  return useBackend<T>('interviews/getCurrentManager')
}

/** POST /api/interviews/getDriverIncidents */
export function useGetDriverIncidents<T = any>() {
  return useBackend<T>('interviews/getDriverIncidents')
}

/** POST /api/interviews/getDriverLastShift */
export function useGetDriverLastShift<T = any>() {
  return useBackend<T>('interviews/getDriverLastShift')
}

/** POST /api/interviews/getDriverOperationalIncidents */
export function useGetDriverOperationalIncidents<T = any>() {
  return useBackend<T>('interviews/getDriverOperationalIncidents')
}

/** POST /api/interviews/getDriverPayslips */
export function useGetDriverPayslips<T = any>() {
  return useBackend<T>('interviews/getDriverPayslips')
}

/** POST /api/interviews/getDriverPerformance */
export function useGetDriverPerformance<T = any>() {
  return useBackend<T>('interviews/getDriverPerformance')
}

/** POST /api/interviews/getDriverRepairs */
export function useGetDriverRepairs<T = any>() {
  return useBackend<T>('interviews/getDriverRepairs')
}

/** POST /api/interviews/getDriverShifts */
export function useGetDriverShifts<T = any>() {
  return useBackend<T>('interviews/getDriverShifts')
}

/** POST /api/interviews/getDuplicateCandidates */
export function useGetDuplicateCandidates<T = any>() {
  return useBackend<T>('interviews/getDuplicateCandidates')
}

/** POST /api/interviews/getIdentityFixups */
export function useGetIdentityFixups<T = any>() {
  return useBackend<T>('interviews/getIdentityFixups')
}

/** POST /api/interviews/getInterviewSchedule */
export function useGetInterviewSchedule<T = any>() {
  return useBackend<T>('interviews/getInterviewSchedule')
}

/** POST /api/interviews/getInterviewScoring */
export function useGetInterviewScoring<T = any>() {
  return useBackend<T>('interviews/getInterviewScoring')
}

/** POST /api/interviews/getInterviews */
export function useGetInterviews<T = any>() {
  return useBackend<T>('interviews/getInterviews')
}

/** POST /api/interviews/getIsAdmin */
export function useGetIsAdmin<T = any>() {
  return useBackend<T>('interviews/getIsAdmin')
}

/** POST /api/interviews/getOnboardingConfirmations */
export function useGetOnboardingConfirmations<T = any>() {
  return useBackend<T>('interviews/getOnboardingConfirmations')
}

/** POST /api/interviews/getOnboardingFixups */
export function useGetOnboardingFixups<T = any>() {
  return useBackend<T>('interviews/getOnboardingFixups')
}

/** POST /api/interviews/getPipeline */
export function useGetPipeline<T = any>() {
  return useBackend<T>('interviews/getPipeline')
}

/** POST /api/interviews/getReferenceReport */
export function useGetReferenceReport<T = any>() {
  return useBackend<T>('interviews/getReferenceReport')
}

/** POST /api/interviews/getResignation */
export function useGetResignation<T = any>() {
  return useBackend<T>('interviews/getResignation')
}

/** POST /api/interviews/getSelectedApplication */
export function useGetSelectedApplication<T = any>() {
  return useBackend<T>('interviews/getSelectedApplication')
}

/** POST /api/interviews/getSuspensionLetterDelivery */
export function useGetSuspensionLetterDelivery<T = any>() {
  return useBackend<T>('interviews/getSuspensionLetterDelivery')
}

/** POST /api/interviews/getUpcomingInterviews */
export function useGetUpcomingInterviews<T = any>() {
  return useBackend<T>('interviews/getUpcomingInterviews')
}

/** POST /api/interviews/getWorklist */
export function useGetWorklist<T = any>() {
  return useBackend<T>('interviews/getWorklist')
}

/** POST /api/interviews/logRefereeAttempt */
export function useLogRefereeAttempt<T = any>() {
  return useBackend<T>('interviews/logRefereeAttempt')
}

/** POST /api/interviews/markApplicationDuplicate */
export function useMarkApplicationDuplicate<T = any>() {
  return useBackend<T>('interviews/markApplicationDuplicate')
}

/** POST /api/interviews/markInterviewFailed */
export function useMarkInterviewFailed<T = any>() {
  return useBackend<T>('interviews/markInterviewFailed')
}

/** POST /api/interviews/markInterviewForReschedule */
export function useMarkInterviewForReschedule<T = any>() {
  return useBackend<T>('interviews/markInterviewForReschedule')
}

/** POST /api/interviews/markInterviewNoShow */
export function useMarkInterviewNoShow<T = any>() {
  return useBackend<T>('interviews/markInterviewNoShow')
}

/** POST /api/interviews/markInterviewPassed */
export function useMarkInterviewPassed<T = any>() {
  return useBackend<T>('interviews/markInterviewPassed')
}

/** POST /api/interviews/markRefereeUnreachable */
export function useMarkRefereeUnreachable<T = any>() {
  return useBackend<T>('interviews/markRefereeUnreachable')
}

/** POST /api/interviews/mergePeople */
export function useMergePeople<T = any>() {
  return useBackend<T>('interviews/mergePeople')
}

/** POST /api/interviews/previewSuspensionLetter */
export function usePreviewSuspensionLetter<T = any>() {
  return useBackend<T>('interviews/previewSuspensionLetter')
}

/** POST /api/interviews/recordInterviewDecision */
export function useRecordInterviewDecision<T = any>() {
  return useBackend<T>('interviews/recordInterviewDecision')
}

/** POST /api/interviews/recordPrdpCard */
export function useRecordPrdpCard<T = any>() {
  return useBackend<T>('interviews/recordPrdpCard')
}

/** POST /api/interviews/recordResignation */
export function useRecordResignation<T = any>() {
  return useBackend<T>('interviews/recordResignation')
}

/** POST /api/interviews/releaseReferenceHold */
export function useReleaseReferenceHold<T = any>() {
  return useBackend<T>('interviews/releaseReferenceHold')
}

/** POST /api/interviews/requestContract */
export function useRequestContract<T = any>() {
  return useBackend<T>('interviews/requestContract')
}

/** POST /api/interviews/requireSecondReference */
export function useRequireSecondReference<T = any>() {
  return useBackend<T>('interviews/requireSecondReference')
}

/** POST /api/interviews/resendStageEmail */
export function useResendStageEmail<T = any>() {
  return useBackend<T>('interviews/resendStageEmail')
}

/** POST /api/interviews/resendSuspensionLetter */
export function useResendSuspensionLetter<T = any>() {
  return useBackend<T>('interviews/resendSuspensionLetter')
}

/** POST /api/interviews/reviseInterviewScore */
export function useReviseInterviewScore<T = any>() {
  return useBackend<T>('interviews/reviseInterviewScore')
}

/** POST /api/interviews/saveDriveScore */
export function useSaveDriveScore<T = any>() {
  return useBackend<T>('interviews/saveDriveScore')
}

/** POST /api/interviews/saveInterviewScore */
export function useSaveInterviewScore<T = any>() {
  return useBackend<T>('interviews/saveInterviewScore')
}

/** POST /api/interviews/sendOnboardingConfirmation */
export function useSendOnboardingConfirmation<T = any>() {
  return useBackend<T>('interviews/sendOnboardingConfirmation')
}

/** POST /api/interviews/sendSuspensionLetter */
export function useSendSuspensionLetter<T = any>() {
  return useBackend<T>('interviews/sendSuspensionLetter')
}

/** POST /api/interviews/sitOutInterview */
export function useSitOutInterview<T = any>() {
  return useBackend<T>('interviews/sitOutInterview')
}

/** POST /api/interviews/submitDrive */
export function useSubmitDrive<T = any>() {
  return useBackend<T>('interviews/submitDrive')
}

/** POST /api/interviews/submitInterviewScorecard */
export function useSubmitInterviewScorecard<T = any>() {
  return useBackend<T>('interviews/submitInterviewScorecard')
}

/** POST /api/interviews/updateApplicationStatus */
export function useUpdateApplicationStatus<T = any>() {
  return useBackend<T>('interviews/updateApplicationStatus')
}

/** POST /api/interviews/updatePersonIdentity */
export function useUpdatePersonIdentity<T = any>() {
  return useBackend<T>('interviews/updatePersonIdentity')
}
